var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "id": "alertcontainer"
    }
  }, [_c('sweet-modal', {
    ref: _vm.uuid,
    attrs: {
      "icon": _vm.type,
      "overlay-theme": "light"
    },
    on: {
      "close": _vm.closeHandler
    }
  }, [_c('div', {
    staticClass: "alertmessage",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fe0a472","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/modalWrapper/Alert.vue
// module id = 1535
// module chunks = 1